import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router";
import filesystem from "../app/filesystem/filesystem";
import { toast } from "react-toastify";
import { getNodeContentId } from "../app/sqlite/utilities";
import Loader from "../components/common/Loader";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";

interface IParams {
  treetype: "meetings" | "boards";
  sourceId: string;
  nodeId: string;
}

const OfflineBrowsePage: React.FC<RouteComponentProps<IParams>> = ({
  match,
  history,
}) => {
  const [t] = useTranslation(["nativeapp"], translationHookOptions);


  const openDocument = async (
    type: "file-opener" | "file-opener-dialog" | "document-viewer"
  ) => {
    try {
      const intNodeId = parseInt(match.params.nodeId);
      if (intNodeId > 0) {
        if (match.params.treetype === "meetings") {
          const contentId = await getNodeContentId(intNodeId, "Meetings");
          const intMeetingId = parseInt(match.params.sourceId);
          if (contentId > 0 && intMeetingId > 0) {
            filesystem.Open.meetingPdf(
              intMeetingId,
              contentId,
              type,
              () => history.goBack(),
              () => {
                toast.error(t("offline_error_opening_file"), {toastId: "OpenDocumentError"});
                history.goBack();
              }
            );
          } else throw new Error("ContentId or MeetingId not valid");
        } else {
          const contentId = await getNodeContentId(intNodeId, "Boards");
          const intBoardId = parseInt(match.params.sourceId);
          if (contentId > 0 && intBoardId > 0) {
            filesystem.Open.boardPdf(
              intBoardId,
              contentId,
              type,
              () => history.goBack(),
              () => {
                toast.error(t("offline_error_opening_file"), {toastId: "OpenDocumentError"});
                history.goBack();
              }
            );
          } else throw new Error("ContentId or BoardId not valid");
        }
      } else throw new Error("NodeId not valid");
    } catch (error) {
      toast.error(t("offline_error_opening_file"), {toastId: "OpenDocumentError"});
      history.goBack();
    }
  };

  useEffect(() => {
    openDocument("document-viewer");

    return () => {};
  }, [openDocument]);

  return <Loader />;
};

export default observer(OfflineBrowsePage);
